import React from "react";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

export default function CourseWidgetPage() {
  const scriptUrl = `${API_BASE}/api/courses/public/widget.js`;
  const courseUrl = `${window.location.origin}/kurse`;

  const embedCode = `<!-- Schwimmkurs-Buchungswidget - DIE FITMACHER -->
<div id="sfw-kurse-widget">
  <script src="${scriptUrl}" data-api="${scriptUrl}" data-url="${courseUrl}"><\/script>
</div>`;

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-2xl">
        <div className="rounded-2xl bg-white shadow-lg p-6 sm:p-8 space-y-6">
          <div>
            <h2 className="text-2xl font-bold text-slate-900">Widget-Einbettungscode</h2>
            <p className="mt-2 text-slate-600">
              Kopieren Sie den folgenden Code und fügen Sie ihn auf Ihrer Homepage ein.
              Das Widget wird sich nahtlos in Ihre Seite einfügen.
            </p>
          </div>

          <div className="rounded-xl bg-slate-900 p-4 overflow-x-auto">
            <pre className="text-sm text-green-400 whitespace-pre-wrap break-all font-mono">
              {embedCode}
            </pre>
          </div>

          <button
            onClick={() => {
              navigator.clipboard.writeText(embedCode);
              alert("Code kopiert!");
            }}
            className="rounded-xl bg-[#003366] px-6 py-3 font-semibold text-white hover:bg-[#004488] transition-colors text-sm"
          >
            Code kopieren
          </button>

          <div className="rounded-xl bg-amber-50 border border-amber-200 p-4 text-sm text-amber-800">
            <strong>Hinweis:</strong> Nach dem Deployment wird die Live-URL automatisch verwendet.
            Das Widget lädt die aktiven Kurse dynamisch und zeigt sie als Teil Ihrer Webseite an — kein iFrame.
          </div>

          {/* Live-Vorschau */}
          <div>
            <h3 className="text-lg font-semibold text-slate-800 mb-3">Vorschau</h3>
            <div className="border rounded-xl p-4 bg-white">
              <WidgetPreview />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


function WidgetPreview() {
  const [courses, setCourses] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    fetch(`${API_BASE}/api/courses/public/active`)
      .then(r => r.json())
      .then(setCourses)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p className="text-slate-400 text-sm">Lade...</p>;
  if (courses.length === 0) return <p className="text-slate-400 text-sm text-center py-4">Aktuell keine Kurse verfügbar.</p>;

  const formatDate = (d) => {
    if (!d) return "";
    try { return new Date(d).toLocaleDateString("de-DE", { day: "2-digit", month: "long", year: "numeric" }); }
    catch { return d; }
  };

  return (
    <div>
      {courses.map((c) => {
        const pct = Math.min(100, ((c.registered_count || 0) / (c.max_participants || 1)) * 100);
        return (
          <div key={c.id} className="border rounded-xl p-4 mb-3 shadow-sm">
            {c.image_url && <img src={`${API_BASE}${c.image_url}`} alt="" className="w-full h-44 object-cover rounded-lg mb-3" />}
            <div className="flex justify-between items-start flex-wrap gap-3">
              <div>
                <h3 className="font-bold text-slate-900">{c.title}</h3>
                {c.weekday_time && <p className="text-sm text-slate-500">{c.weekday_time}</p>}
                <p className="text-sm text-slate-500">Beginn: {formatDate(c.start_date)}</p>
                <p className={`text-sm font-semibold ${c.is_full ? "text-red-600" : "text-emerald-600"}`}>
                  {c.is_full ? "Ausgebucht" : `${c.spots_available} von ${c.max_participants} Plätzen frei`}
                </p>
              </div>
              {!c.is_full && (
                <a href="/kurse" className="rounded-lg bg-[#003366] px-5 py-2.5 text-white text-sm font-semibold hover:bg-[#004488]">
                  Jetzt anmelden
                </a>
              )}
            </div>
            <div className="h-1 bg-slate-100 rounded-full mt-3">
              <div className={`h-full rounded-full ${c.is_full ? "bg-red-500" : "bg-emerald-500"}`} style={{ width: `${pct}%` }} />
            </div>
          </div>
        );
      })}
    </div>
  );
}
